import { NavigationMenu } from "@patient-watch/ui/navigation-menu";
import { cn } from "@/lib/utils";

import AppDesktopNavigation from "../app/DesktopNavigation";
import Breadcrumb from "./Breadcrumb";
import { Burger } from "./Burger";
import MainIcon from "./MainIcon";

const Navigation = () => {
    return (
        <nav
            className={cn(
                "top-0 z-30 sticky flex bg-indigo-100 dark:bg-slate-900 bg-opacity-50 dark:bg-opacity-50 backdrop-blur-xl m-auto my-auto px-2 lg:px-4 py-2.5 border-indigo-200 border-y dark:border-slate-500 !w-full item-center"
            )}
        >
            {/* Desktop */}
            <section className="hidden lg:flex w-full">
                <div className="flex justify-between items-center gap-x-6 !w-full">
                    <div className="flex flex-1 items-center min-w-0">
                        <MainIcon />
                        <Breadcrumb />
                    </div>
                    <div className="flex justify-center items-center gap-x-4 my-auto ml-auto text-md shrink-0">
                        <NavigationMenu>
                            <AppDesktopNavigation />
                        </NavigationMenu>
                    </div>
                </div>
            </section>

            {/* Mobile */}
            <section className="lg:hidden z-20 !w-full">
                <div className="flex justify-between items-center gap-x-2 !w-full">
                    <div className="flex flex-1 items-center min-w-0">
                        <MainIcon />
                        <Breadcrumb backOnly={true} />
                    </div>

                    <Burger />
                </div>
            </section>
        </nav>
    );
};

export default Navigation;
